import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { EducationTypeItem, EducationType } from '../models';

export class EducationTypeApi extends ApiModule {
  protected endpoint = '/education-type';

  public async pageEducationTypes(params: any) {
    return this.api.post<PaginatedResponseData<EducationTypeItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadEducationTypeDetails(id: number) {
    return this.api.get<EducationType>(`${this.endpoint}?id=${id}`);
  }

  public saveEducationType(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteEducationType(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }

  public getList() {
    return this.api.get<EducationType[]>(`${this.endpoint}/list`);
  }
}
